export default __webpack_public_path__ + "static/media/Energodinamiki.30e752ab.png";